import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { XAutoComplete } from "share-components/mui-wrap/auto-complete/x-auto-complete";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import {
  MaterialGroupSelectionKey,
  useMaterialGroupSelection,
} from "./use-material-group-selection";

type MaterialGroupSelectionProps = {
  codeSelected: string;
  typeSelected: string;
  nameSelected: string;
  barcodeSelected?: string;
  setSelectionProp: (prop: MaterialGroupSelectionKey, value: string) => void;
};

export const MaterialGroupSelection = observer(
  ({
    codeSelected,
    typeSelected,
    nameSelected,
    barcodeSelected,
    setSelectionProp,
  }: MaterialGroupSelectionProps) => {
    const { searchCodeOptions, searchTypeOptions, searchNameOptions } =
      useMaterialGroupSelection({
        codeSelected,
        typeSelected,
        nameSelected,
      });

    return (
      <>
        <Box sx={{ minWidth: 220 }}>
          <XAutoComplete
            label="Bộ phận/Khâu SX"
            value={codeSelected}
            searchFunc={searchCodeOptions}
            searchOnFocus={true}
            searchWhenRender={true}
            onValueChanged={(v) => {
              const value = v?.value ?? "";
              setSelectionProp("code", value);
            }}
          />
        </Box>
        <Box sx={{ minWidth: 220 }}>
          <XAutoComplete
            label="Loại Hàng"
            value={typeSelected}
            searchFunc={searchTypeOptions}
            searchOnFocus={true}
            searchWhenRender={true}
            onValueChanged={(v) => {
              setSelectionProp("type", v?.value ?? "");
            }}
          />
        </Box>
        <Box sx={{ minWidth: 220 }}>
          <XAutoComplete
            label="Tên Hàng (Mã Hàng)"
            value={nameSelected}
            searchFunc={searchNameOptions}
            searchOnFocus={true}
            searchWhenRender={true}
            onValueChanged={(v) => setSelectionProp("name", v?.value ?? "")}
          />
        </Box>
        <Box sx={{ minWidth: 220 }}>
          <XSearchTextField
            label="Mã barcode"
            value={barcodeSelected ?? ""}
            onChange={(e) => setSelectionProp("barcode", e.currentTarget.value)}
            style={{ width: '100%' }}
          />
        </Box>
      </>
    );
  },
);
